<template>
  <div>
    <div class="row mb-3">
      <div class="col">
        <label>Attrbute key</label>
        <input class="form-control" v-model="attr.attr_key" />
      </div>
      <div class="col">
        <label>Attribute type</label>
        <select class="form-control" v-model="attr.attr_type">
          <option v-for="(type, index) in types" :value="type" :key="index">{{ type | t }}</option>
        </select>
      </div>
      <div class="col">
        <label>Category</label>
        <input class="form-control" v-model="attr.category" /><small>{{
          'Prepend with x: to sort the category over others. Put x: only to group attrs without a category name. Replace x with a number'
        }}</small>
      </div>
      <div class="col">
        <label>Priority</label>
        <input class="form-control" type="number" v-model="attr.priority" />
      </div>
      <div class="col-auto">
        <button class="btn btn-outline-danger" @click="$emit('remove')">Remove attribute</button>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" v-model="attr.is_required" />
          <label class="text-muted">Is required</label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="attr.requirement_type"
            true-value="customer_input"
            false-value="carrier_details"
          />
          <label class="text-muted">Is setup details</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" v-model="attr.only_visible_on_creation" />
          <label class="text-muted">Only visible on creation</label>
        </div>
      </div>
    </div>
    <div class="row mb-5" v-if="attr.attr_type == 'enum' || attr.attr_type == 'enum_multi_select'">
      <div class="col">
        <div class="input-group">
          <input
            class="form-control input-sm"
            placeholder="Enum value"
            v-model="new_enum_value"
            @keyup.enter="add_enum"
          /><span class="input-group-btn">
            <button class="btn btn-seconday" @click="add_enum">{{ 'add' | t }}</button></span
          >
        </div>
        <div class="form-control">
          <button class="btn btn-primary mr-2" v-for="(_enum, i) in attr.local_attr_enums">
            {{ _enum.enum_name
            }}<span class="badge badge-light ml-2" @click="attr.local_attr_enums.splice(i, 1)">&times;</span>
          </button>
          <div class="text-secondary" v-if="attr.local_attr_enums.length == 0">{{ 'Currently no enum options' }}</div>
        </div>
      </div>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th>Translations</th>
          <th></th>
          <th></th>
          <th class="text-right">
            <button class="btn btn-sm btn-outline-primary" @click="add_translation">Add translation</button>
          </th>
        </tr>
        <tr>
          <th>Language</th>
          <th>Label</th>
          <th class="text-right">Help text</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Default</td>
          <td>
            <input class="form-control" v-model="attr.attr_name" />
          </td>
          <td>
            <textarea class="form-control" v-model="attr.description"></textarea>
          </td>
        </tr>
        <tr v-for="(translation, i) in attr.local_attr_translations">
          <td>
            <select class="form-control" v-model="translation.locale">
              <option>--</option>
              <option value="da">Danish</option>
              <option value="en">English</option>
            </select>
          </td>
          <td>
            <input class="form-control" v-model="translation.translation_label" />
          </td>
          <td class="text-right">
            <textarea class="form-control" v-model="translation.translation_help_text"></textarea>
          </td>
          <td class="text-danger text-right">
            <i class="fa fa-ban" @click="attr.local_attr_translations.splice(i, 1)"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: ['value'],
  data: function () {
    return {
      new_enum_value: '',
      display: false,
      types: [
        'string',
        'textarea',
        'integer',
        'password',
        'boolean',
        'enum',
        'enum_multi_select',
        'image',
        'sender_address',
        'time_of_day'
      ]
    };
  },
  methods: {
    add_enum() {
      this.attr.local_attr_enums.push({
        enum_name: this.new_enum_value,
        enum_value: this.new_enum_value
      });
      this.new_enum_value = '';
    },
    add_translation() {
      this.attr.local_attr_translations.push({
        locale: null,
        translation_label: '',
        translation_help_text: ''
      });
    }
  },
  computed: {
    attr() {
      return this.value;
    }
  }
};
</script>
